import React, { useState, FC } from 'react';
import { Entry, EntryFields } from 'contentful';
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import {
  ArticleTabs,
  TabButton,
  TabsContainer,
  TabContent,
} from './components/styled';

// eslint-disable-next-line import/no-cycle
import { RICH_TEXT_RENDERER_OPTIONS } from 'constants/richTextRendererOptions';

export type TabsData = {
  name: string;
  tabEntries: TabEntry[];
};

type TabEntry = Entry<{
  name: string;
  label: string;
  // Need to enforce type for body.nodeType
  // Otherwise, we get the below error
  // Type '"document"' is not assignable to type 'BLOCKS.DOCUMENT'. ts(2345)
  body: EntryFields.RichText & {
    nodeType: BLOCKS.DOCUMENT;
  };
}>;

type TabsProps = {
  tabsData: Entry<TabsData>;
};

const TabGroup: FC<TabsProps> = ({
  tabsData = { fields: { tabEntries: [] } },
}) => {
  const [selected, setSelected] = useState(0);

  return tabsData?.fields?.tabEntries ? (
    <TabsContainer>
      <ArticleTabs>
        {(tabsData?.fields?.tabEntries || []).map((tab, index) =>
          tab?.fields ? (
            <TabButton
              key={tab.fields?.label}
              selected={index === selected}
              onClick={() => setSelected(index)}
            >
              {tab.fields?.label}
            </TabButton>
          ) : null,
        )}
      </ArticleTabs>
      <TabContent>
        {documentToReactComponents(
          tabsData?.fields?.tabEntries?.[selected]?.fields?.body,
          RICH_TEXT_RENDERER_OPTIONS,
        )}
      </TabContent>
    </TabsContainer>
  ) : null;
};

export default TabGroup;
